import type { MemberCardData } from "@components/common/MemberCard";

export interface ApiCommitteeMember {
	id: number;
	uuid: string;
	memberType?: string;
	user: {
		id: number;
		uuid: string;
		firstName: string;
		lastName: string;
		emailAddress: string;
		phoneNumber: string;
		profilePicture?: string | null;
		committeeMember?: {
			grade?: number;
			dateOfJoining?: string;
			technology?: {
				name?: string;
			};
			memberType?: {
				name?: string;
			};
			committeeMemberTechnologies?: Array<{
				technology?: {
					name?: string;
				};
			}>;
		};
	};
	isConvener: boolean;
	assignedCourses?: Array<{
		id: number;
		uuid: string;
		course: {
			id: number;
			uuid: string;
			name: string;
		};
	}>;
	assignedLabs?: Array<{
		id: number;
		uuid: string;
		lab: {
			id: number;
			uuid: string;
			name: string;
		};
	}>;
}

export const mapCommitteeMemberToCardData = (member: ApiCommitteeMember): MemberCardData => {
	const dateOfJoining = member?.user?.committeeMember?.dateOfJoining;
	let experience: string | undefined;
	if (dateOfJoining) {
		try {
			const joiningDate = new Date(dateOfJoining);
			const currentDate = new Date();
			const experienceYears = Math.floor((currentDate.getTime() - joiningDate.getTime()) / (1000 * 60 * 60 * 24 * 365));
			experience = `${experienceYears} Years`;
		} catch {
			experience = undefined;
		}
	}

	const technologyNames =
		member.user?.committeeMember?.committeeMemberTechnologies
			?.map(item => item?.technology?.name)
			.filter((name): name is string => Boolean(name)) ?? [];

	const technology =
		technologyNames.length > 0
			? technologyNames.join(", ")
			: member.user?.committeeMember?.technology?.name;

	const assignedCourseNames =
		member.assignedCourses?.map(course => course?.course?.name).filter((name): name is string => Boolean(name)) ?? [];

	const assignedLabNames =
		member.assignedLabs?.map(item => item?.lab?.name).filter((name): name is string => Boolean(name)) ?? [];

	const memberType = member.memberType || member.user?.committeeMember?.memberType?.name;

	return {
		id: member.id,
		uuid: member.uuid,
		name: `${member?.user?.firstName || ""} ${member?.user?.lastName || ""}`.trim() || "N/A",
		email: member?.user?.emailAddress,
		phoneNumber: member?.user?.phoneNumber,
		grade: member?.user?.committeeMember?.grade,
		experience,
		technology,
		memberType,
		assignedCourses: assignedCourseNames.length > 0 ? assignedCourseNames.join(", ") : undefined,
		assignedLabs: assignedLabNames.length > 0 ? assignedLabNames.join(", ") : undefined,
		isConvener: member?.isConvener,
		profilePicture: member?.user?.profilePicture,
	};
};
